import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDeleteDocument } from '../hooks/useDeleteDocument'

interface ModalDeleteDocumentProps {
  documentId?: string
  onError: (error: ErrorResponse) => void
  operationKlassToCheckPermission?: string
}

export const ModalDeleteDocument = ({ documentId, onError, operationKlassToCheckPermission }: ModalDeleteDocumentProps) => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const [isOpen, setIsOpen] = useState(false)

  const onSuccess = () => {
    setIsOpen(false)
    queryClient.invalidateQueries({ queryKey: ['generalDocument', documentId] })
    queryClient.invalidateQueries({ queryKey: ['generalDocuments'] })
    navigate('/general-documents')
  }

  const { mutate: deleteDocument, isPending: deleteDocumentIsPending } = useDeleteDocument({
    onSuccess,
    onError: (error) => {
      setIsOpen(false)
      onError(error)
    },
  })

  return (
    <Modal
      Trigger={
        <Button operationKlassToCheckPermission={operationKlassToCheckPermission} type="button" variant="error" className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
          Deletar
        </Button>
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Você tem certeza?"
      showClose={false}
      useCancellableFooter
      confirmButtonText="Deletar documento"
      disabled={deleteDocumentIsPending}
      onConfirm={() => deleteDocument(documentId)}
    />
  )
}
